import { useRef, useEffect, useState } from "react";
import { Footer, NavbarUser, Navbar } from '../../containers';
import "./bookedpubcrawldetails.css";
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import api from "../../api/axios";

const BookedPubCrawlDetails = () => {

    const { t } = useTranslation();
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    // Footer calculation
    const footerRef = useRef(null);
    const [footerHeight, setFooterHeight] = useState(0);
    // Navbar calculation
    const [navbarHeight, setNavbarHeight] = useState(0);
    const [pictureSrc, setPictureSrc] = useState("");

    const location = useLocation();
    const navigate = useNavigate();
    const { eventid } = location.state || {};
    const [eventDetails, setEventDetails] = useState(null);

    useEffect(() => {
        const token = sessionStorage.getItem("token");
        setIsAuthenticated(!!token);

        // Footer height calculation
        if (footerRef.current) {
            setFooterHeight(footerRef.current.clientHeight);
        }

        // Navbar height calculation
        // Navbar height calculation
        const navbarElement = document.querySelector('.navbarUser');
        if (navbarElement) {
            const navbarHeight = navbarElement.offsetHeight;
            setNavbarHeight(navbarElement.offsetHeight);
        }

        const fetchPicture = async () => {
            try {
                const pictureId = 22; // Reusing same background logic
                const response = await api.get(`/user/getwebsitepicture/${pictureId}`);
                setPictureSrc(response.data.picture);
            } catch (err) {
                console.error("Error fetching picture:", err);
            }
        };

        const fetchEventDetails = async () => {
            if (!eventid) return;
            try {
                const response = await api.post("/user/event/pubcrawldetails", { eventid });
                setEventDetails(response.data);
            } catch (error) {
                console.error("Error fetching event details:", error);
            }
        };

        fetchPicture();
        if (token) {
            fetchEventDetails();
        }

        // Scroll to top on page load
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [eventid]);

    const formatEventDate = (dateString) => {
        if (!dateString) return "";
        const options = {
            timeZone: 'Europe/Berlin',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        };
        return new Intl.DateTimeFormat('de-DE', options).format(new Date(dateString));
    };

    if (!isAuthenticated) {
        return (
            <div className="wrapper-booked-pub-crawl" style={{ backgroundImage: pictureSrc ? `url(${pictureSrc})` : "none" }}>
                <Navbar />
                <div className="booked-pub-crawl-site" style={{ minHeight: `calc(100vh - ${footerHeight}px)`, paddingTop: `${navbarHeight + 20}px` }}>
                    <div className="booked-pub-crawl-content-parent">
                        <p>{t('NoEventDataLoggedIn')}</p>
                        <button onClick={() => navigate('/')}>{t('EventBackToHomepage')}</button>
                    </div>
                </div>
                <div ref={footerRef}>
                    <Footer />
                </div>
            </div>
        );
    }

    return (
        <div className="wrapper-booked-pub-crawl" style={{ backgroundImage: pictureSrc ? `url(${pictureSrc})` : "none", }}>
            <NavbarUser />
            <div className="booked-pub-crawl-site" style={{ minHeight: `calc(100vh - ${footerHeight}px)`, paddingTop: `${navbarHeight + 20}px` }}>
                <div className="booked-pub-crawl-content-parent">
                    <h1>{t('BookedEventsEventType')} {eventDetails?.eventname || "Pub Crawl"}</h1>
                    {eventDetails ? (
                        <div className="booked-pub-crawl-content-child">
                            <p><strong>{t('BookedPubEventDate')}</strong> {formatEventDate(eventDetails.date)}</p>
                            <p><strong>{t('BookedPubEventAddress')}</strong> {eventDetails.adresse}</p>
                            <p><strong>{t('BookedPubEventStart')}</strong> {eventDetails.lokal}</p>
                            <p><strong>{t('BookedPubEventTime')}</strong> {eventDetails.time}</p>
                            <p><strong>{t('BookedPubEventDescription')}</strong> {eventDetails.description}</p>
                        </div>
                    ) : (
                        <p>{t('BookedPubEventLoading')}...</p>
                    )}
                    <button onClick={() => navigate('/profile/myevents')} style={{ marginTop: '20px' }}>
                        {t('BookedPubEventBack')}
                    </button>
                </div>
            </div>
            <div ref={footerRef}>
                <Footer />
            </div>
        </div>
    );
};

export default BookedPubCrawlDetails;
